// extracted by mini-css-extract-plugin
export var quantityInput = "_kb-0";